import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList,{attrs:{"dense":""}},_vm._l((_vm.farmers),function(farmer,f){return _c(VListItem,{directives:[{def: Ripple,name:"ripple",rawName:"v-ripple"}],key:farmer.id,staticClass:"command",class:{selected: _vm.index === f},on:{"click":function($event){return _vm.$emit('pseudo', farmer.name)}}},[_c('avatar',{attrs:{"farmer":farmer}}),_c(VListItemTitle,[_vm._v("@"+_vm._s(farmer.name))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }